export type HeroImageSource = {
    src: string;
    type: string;
}

export type HeroImageItem = {
    type: 'image' | 'video';
    source: HeroImageSource[];
}

const heroImages: Record<string, HeroImageItem> = {
    'still-webp': {
        type: 'video',
        source: [
            {
                src: '/videos/hero-square.webm',
                type: 'video/webm',
            },
            {
                src: '/videos/hero-square.mp4',
                type: 'video/mp4',
            },
        ]
    },
    'hero-1': {
        type: 'image',
        source: [
            {
                src: 'https://res.cloudinary.com/dxd5axwvg/image/upload/v1748955754/Hero/hero-1_xbgl6t.webp',
                type: 'image/webp',
            },
        ],
    },
    'hero-2': {
        type: 'image',
        source: [
            {
                src: 'https://res.cloudinary.com/dxd5axwvg/image/upload/v1748955753/Hero/hero-4_op2b26.webp',
                type: 'image/webp',
            },
        ],
    },
    'hero-3': {
        type: 'image',
        source: [
            {
                src: 'https://res.cloudinary.com/dxd5axwvg/image/upload/v1748955751/Hero/hero-7_pacrbd.webp',
                type: 'image/webp',
            },
        ],
    },
    'hero-4': {
        type: 'image',
        source: [
            {
                src: 'https://res.cloudinary.com/dxd5axwvg/image/upload/v1748955750/Hero/hero-2_ni5eku.webp',
                type: 'image/webp',
            },
        ],
    },
    'hero-5': {
        type: 'image',
        source: [
            {
                src: 'https://res.cloudinary.com/dxd5axwvg/image/upload/v1748957092/Hero/hero-5-original_mgf3vt.webp',
                type: 'image/webp',
            },
        ],
    },
    'hero-6': {
        type: 'image',
        source: [
            {
                src: 'https://res.cloudinary.com/dxd5axwvg/image/upload/v1748956908/Hero/hero-5_t1nbtg.webp',
                type: 'image/webp',
            },
        ],
    },
    'hero-7': {
        type: 'image',
        source: [
            {
                src: 'https://res.cloudinary.com/dxd5axwvg/image/upload/v1748955752/Hero/hero-8_oa0ke3.webp',
                type: 'image/webp',
            },
        ],
    },
    'hero-8': {
        type: 'image',
        source: [
            {
                src: 'https://res.cloudinary.com/dxd5axwvg/image/upload/v1748956908/Hero/hero-3_cu0hbz.webp',
                type: 'image/webp',
            },
        ],
    },
    'hero-9': {
        type: 'image',
        source: [
            {
                src: 'https://res.cloudinary.com/dxd5axwvg/image/upload/v1748957091/Hero/hero-3-original_bl7o56.webp',
                type: 'image/webp',
            },
        ],
    },
    'hero-10': {
        type: 'image',
        source: [
            {
                src: 'https://res.cloudinary.com/dxd5axwvg/image/upload/v1748955750/Hero/hero-6_q8dfsy.webp',
                type: 'image/webp',
            },
        ],
    },
    'hero-11': {
        type: 'image',
        source: [
            {
                src: 'https://res.cloudinary.com/dxd5axwvg/image/upload/v1748955755/Hero/hero-9_fqsegd.webp',
                type: 'image/webp',
            },
        ],
    },
}

export default heroImages;

export type HeroImage = keyof typeof heroImages;